export default __webpack_public_path__ + "navigation-examples-predictive-caching-960-835bf3f69b972b7cf7b6005353de81bf.png";